import { Pipe, PipeTransform } from "@angular/core";
import { DateTime } from "luxon";
import { CoreFormatService } from "../services/core-format.service";

@Pipe({ name: 'formatCurrency' })
export class CoreFormatCurrencyPipe implements PipeTransform {
  constructor(
    private coreFormatService: CoreFormatService
  ) { }

  transform(amount: number, currency?: string, format?: string, inverted: boolean = false) {
    return this.coreFormatService.CurrencyAmount(amount, currency, format, inverted);
  }
}
@Pipe({ name: 'currencyFormat', standalone: true })
export class CoreStdFormatCurrencyPipe implements PipeTransform {
  constructor(
    private coreFormatService: CoreFormatService
  ) { }

  transform(amount: number, currency?: string, format?: string, inverted: boolean = false) {
    return this.coreFormatService.CurrencyAmount(amount, currency, format, inverted);
  }
}
@Pipe({ name: 'formatDateTime' })
export class CoreFormatDateTimePipe implements PipeTransform {
  constructor(
    private coreFormatService: CoreFormatService
  ) { }

  transform(datetime: DateTime, format?: string) {
    if(!datetime.isValid) return '';
    if(format) return datetime.toFormat(format);
    return datetime.toFormat(this.coreFormatService.DateAndTimeFmt());
  }
}
@Pipe({ name: 'dateTimeFormat', standalone: true })
export class CoreStdFormatDateTimePipe implements PipeTransform {
  constructor(
    private coreFormatService: CoreFormatService
  ) { }

  transform(datetime: DateTime, format?: string) {
    if(!datetime.isValid) return '';
    if(format) return datetime.toFormat(format);
    return datetime.toFormat(this.coreFormatService.DateAndTimeFmt());
  }
}

@Pipe({ name: 'formatDayOfWeek' })
export class CoreFormatDayOfWeekPipe implements PipeTransform {
  transform(day: string) {
    switch (day.toLowerCase()) {
      case 'mon':
        return 'Monday';
      case 'tue':
        return 'Tuesday';
      case 'wed':
        return 'Wednesday';
      case 'thu':
        return 'Thursday';
      case 'fri':
        return 'Friday';
      case 'sat':
        return 'Saturday';
      case 'sun':
        return 'Sunday';
      default:
        return '';
    }
  }
}

@Pipe({ name: 'formatPercentualNumber' })
export class CoreFormatPercentualNumberPipe implements PipeTransform {
  constructor(
    private coreFormatService: CoreFormatService
  ) { }

  transform(value: number) {
    return this.coreFormatService.PercentualNumber(value);
  }
}

@Pipe({ name: 'truncate' })
export class CoreFormatTruncatePipe implements PipeTransform {
  transform(value: string, length: number = 30) {
    return value.length > length ? value.substring(0, length) + '...' : value;
  }
}

@Pipe({ name: 'arrayJoin' })
export class CoreFormatArrayJoinPipe implements PipeTransform {
  transform(values: string[], separator: string = ' - ') {
    return values.filter(value=>value.length>0).join(separator);
  }
}
